import { render, staticRenderFns } from "./MostTruckTrailer.vue?vue&type=template&id=056f4990&"
import script from "./MostTruckTrailer.vue?vue&type=script&lang=js&"
export * from "./MostTruckTrailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports